import { MeetingMemberPreferences, NameListMode } from '../services/meetingService';

export interface PreferenceSummaryLine {
  label: string;
  value: string;
}

export function nameListSummaryLine(mode: NameListMode): PreferenceSummaryLine {
  switch (mode) {
    case 'now':
      return { label: 'Name on list', value: 'Showing now' };
    case 'when_workshop_starts':
      return { label: 'Name on list', value: 'When workshop starts' };
    default:
      return { label: 'Name on list', value: "Don't ever show" };
  }
}

export function phoneListSummaryLine(
  preferences: MeetingMemberPreferences,
  profilePhone?: string
): PreferenceSummaryLine {
  if (!preferences.include_on_printed_phone_list) {
    return { label: 'Phone on list', value: 'No' };
  }
  const phone = profilePhone?.trim();
  return { label: 'Phone on list', value: phone || 'Yes — add your number' };
}

export function emailListSummaryLine(
  preferences: MeetingMemberPreferences,
  userEmail?: string
): PreferenceSummaryLine {
  if (!preferences.include_email_on_list) {
    return { label: 'Email on list', value: 'No' };
  }
  const email = userEmail?.trim();
  return { label: 'Email on list', value: email || 'Yes' };
}

export function sponsorSummaryLine(
  preferences: MeetingMemberPreferences
): PreferenceSummaryLine {
  switch (preferences.sponsor_willingness) {
    case 'yes':
      return { label: 'Available to sponsor', value: 'Yes' };
    case 'temporary':
      return { label: 'Available to sponsor', value: 'Temporary' };
    default:
      return { label: 'Available to sponsor', value: 'No' };
  }
}

export function preferencesCardSubtitle(
  preferences: MeetingMemberPreferences,
  profilePhone?: string
): string {
  const shared: string[] = [];
  if (preferences.include_email_on_list) shared.push('email');
  if (preferences.include_on_printed_phone_list) {
    shared.push(profilePhone?.trim() ? 'phone' : 'phone (add number)');
  }

  let contact: string;
  if (shared.length === 0) {
    contact = 'No contact info shared';
  } else if (shared.length === 1) {
    contact = `Sharing ${shared[0]}`;
  } else {
    contact = 'Sharing phone and email';
  }

  let name: string;
  switch (preferences.name_list_mode) {
    case 'now':
      name = 'name on list now';
      break;
    case 'when_workshop_starts':
      name = 'name at start';
      break;
    default:
      name = 'name not listed';
  }

  let sentence = `${contact}; ${name}`;

  if (preferences.sponsor_willingness === 'yes') {
    sentence += '; open to sponsor';
  } else if (preferences.sponsor_willingness === 'temporary') {
    sentence += '; temp sponsor';
  }

  return `${sentence.charAt(0).toUpperCase()}${sentence.slice(1)}.`;
}
